import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getLocalStorageItem } from "../Helper/helper";

const PublicRoute = ({ children }) => {
	const isLoggedIn = useSelector((state) => state.userStore.isLoggedIn);
	const AUTH_TOKEN = getLocalStorageItem("ORDER_AUTH_TOKEN");

	if (isLoggedIn && AUTH_TOKEN) {
		return <Navigate to="/bids" />;
	} else {
		return children;
	}
};
export default PublicRoute;
